<div class="blockStyle" [ngStyle]="{
  'background-color': currentColor, 
  'display': 'inline-block',
  'height': '10px',
  'width': '10px',
  'border-radius': '50%',
  'margin-right': '5px',
  'vertical-align': 'middle'
}">
</div>